/*
  Snusify: product-card titles truncate on whole words.

  CSS text-overflow cuts mid-word ("LOOP Red Chili Melon Normal 6m…"). This
  measures each .snusify-pcard-name and drops trailing words until the title
  fits its line, with nothing appended after the last whole word. The full
  title is kept in data-full-title (and in the link's title attribute) and is
  re-fitted whenever the card changes width or new cards are rendered — tab
  panels, sliders and section reloads included. A single word that is wider
  than the card falls back to the CSS ellipsis.
*/
(() => {
  const SELECTOR = '.snusify-pcard-name';
  const ELLIPSIS = ''; // whole words only, no trailing mark

  const fit = (el) => {
    const full = el.dataset.fullTitle || (el.dataset.fullTitle = el.textContent.trim());
    el.textContent = full;
    if (el.clientWidth === 0 || el.scrollWidth <= el.clientWidth) return;

    const words = full.split(/\s+/);
    while (words.length > 1) {
      words.pop();
      el.textContent = words.join(' ') + ELLIPSIS;
      if (el.scrollWidth <= el.clientWidth) return;
    }
    el.textContent = full; // one word: let CSS clip it (no ellipsis, see CSS)
  };

  const seen = new WeakSet();
  const ro = 'ResizeObserver' in window ? new ResizeObserver((entries) => entries.forEach((e) => fit(e.target))) : null;

  const attach = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((el) => {
      if (seen.has(el)) return;
      seen.add(el);
      fit(el);
      ro && ro.observe(el);
    });
  };

  const refitAll = () => document.querySelectorAll(SELECTOR).forEach(fit);

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches(SELECTOR)) attach(node.parentNode || document);
        else if (node.querySelector) attach(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  attach();
  document.fonts && document.fonts.ready.then(refitAll);
  addEventListener('resize', refitAll);
  document.addEventListener('shopify:section:load', () => attach());
  document.addEventListener('page:loaded', () => attach());
  window.snusifyFitTitles = refitAll;
})();
